export default __webpack_public_path__ + "static/media/Panaah_Logo-01.4f500fc8.png";